// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1Nx4_","header":"MessagesList_header__3j-6c","chat":"MessagesList_chat__2uWv9"};